import { create } from 'zustand'

const useNotificationsStore = create((set) => ({
    unreadCount: 0,

    setUnreadCount: (unreadCount) => set({ unreadCount: Math.max(0, unreadCount) }),

    incrementUnread: () => set((state) => ({ unreadCount: state.unreadCount + 1 })),

    resetUnread: () => set({ unreadCount: 0 }),

    decrementUnreadBy: (n) => set((state) => ({ unreadCount: Math.max(0, state.unreadCount - n) })),
}))

export default useNotificationsStore
